import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import PerformanceApi from 'api/executive/performance.api'
import type {
  AvgBillPerVisitResponse,
  GetAvgBillPerVisitParams,
} from 'api/executive/executive.types'

export function useAvgBillPerVisit() {
  return useExecutiveQuery<GetAvgBillPerVisitParams, AvgBillPerVisitResponse>(
    'performance.avg-bill-per-visit',
    PerformanceApi.getAvgBillPerVisit,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        patientType: f.patientType ?? undefined,
      }
    }
  )
}
